import api from 'service/api'

const dponetAPI = api.create('dponet')

const listByCompany = async () => {
  return await dponetAPI.get('legal_frameworks/list_by_company')
}

export default { listByCompany }
